import { ReactElement } from 'react'
import ElementProblemsList from '@editor/components/ElementProblemsList'
import { useSelectedElementProblems } from '@editorHooks'

interface Props {
  selectedElement: string
  selectedOpeningGuid?: string | null
}

const SelectedElementProblemsList = ({
  selectedElement,
  selectedOpeningGuid,
}: Props): ReactElement | null => {
  const { filteredProblems, isEmpty } = useSelectedElementProblems({
    selectedElement,
    selectedOpeningGuid,
  })

  if (isEmpty) return null

  return <ElementProblemsList problems={filteredProblems} />
}

export default SelectedElementProblemsList
